import React from 'react'
import PropTypes from 'prop-types'
import ProgressBar from './ProgressBar'

const Thanks = ({ organisations, businessArea, targetGroup, upsellRounds, children }) => {
  const catalogForOrder = (orga) => {
    return orga.catalogs.find(({ target_groups }) => {
      switch(businessArea) {
        case 'schueleraustausch':
          return target_groups.includes("teenagers")
        case 'sprachreisen':
          return target_groups.includes(targetGroup)
        default:
          throw new Error(`Missing Business Area`)
      }
    })
  }

  const catalogDownloadUrlFor = (catalog) => {
    // NOTE: Once we use this url elsewhere, move it to a constant, or
    // if necessary make it a configurable prop.
    return `https://ak-catalogs.s3.eu-central-1.amazonaws.com/${catalog.s3_object_key}`
  }

  return (
    <>
      <ProgressBar max={upsellRounds} current={upsellRounds} finished={true}/>
      <div className='mb-4'>
        <h1>Danke für deine Bestellung!</h1>
        <p>
          Wir haben deine Daten an die von dir ausgewählte(n) Organisation(en) weitergeleitet.
          Diese werden dir ihren Katalog mit den aktuellen Preisen und Informationen zukommen
          lassen – entweder per Post oder als PDF, je nach Verfügbarkeit.
        </p>
        <p>
          Damit du schon vorab einen Blick werfen kannst, haben wir dir die uns vorliegenden
          Kataloge per E-Mail geschickt. Du kannst die PDFs auch hier herunterladen, sofern
          verfügbar.
        </p>
      </div>
      {organisations.length
       ? (
         <div className='vstack gap-3 mb-4'>
           {organisations.map(orga => (
             catalogForOrder(orga) && (
               <a
                 target="_blank" variant='outline-primary'
                 key={orga.id}
                 className='hstack gap-3'
                 href={catalogDownloadUrlFor(catalogForOrder(orga))}
               >
                 <img src={orga.logo_url} className='img-fluid' width='32' />
                 Download {orga.shortname} Katalog
               </a>
             )
           ))}
         </div>)
       : (<></>)}
      {children}
    </>
  )
}

Thanks.propTypes = {
  organisations: PropTypes.arrayOf(PropTypes.object).isRequired,
  businessArea: PropTypes.string.isRequired,
  targetGroup: PropTypes.string,
  upsellRounds: PropTypes.number.isRequired,
}

export default Thanks
